var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletConnect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2497 2497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3396FF;stroke:#66B1FF;stroke-width:3;stroke-miterlimit:22.9256;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2806050136896"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1249,
    cy: 1249,
    r: 1247
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M764,930c267-261,701-261,969,0l32,31c13,13,13,34,0,47l-110,107c-7,7-18,7-24,0l-44-43    c-187-182-489-182-676,0l-47,46c-7,7-18,7-24,0l-110-107c-13-13-13-34,0-47l35-34H764z M1960,1152l98,96c13,13,13,34,0,47    l-442,431c-13,13-35,13-48,0l-314-306c-3-3-9-3-12,0l-314,306c-13,13-35,13-48,0l-442-431c-13-13-13-34,0-47l98-96    c13-13,35-13,48,0l314,306c3,3,9,3,12,0l314-306c13-13,35-13,48,0l314,306c3,3,9,3,12,0l314-306C1925,1139,1947,1139,1960,1152    L1960,1152z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/walletConnect.949fc82d95dc604a9ad194d0fe28e6b5.svg";
export { ForwardRef as ReactComponent };